const fr: Record<string, string> = {
  'features.language.code.fr': 'Français',
  'features.language.code.en': 'Anglais',
  'features.language.code.de': 'Allemand',

  'features.language.wordType.noun': 'Nom',
  'features.language.wordType.adjective': 'Adjectif',
  'features.language.wordType.verb': 'Verbe',

  'features.language.setupTitle': 'Configurez la paire de langues de ce projet',
  'features.language.setupHelp': 'Choisissez la langue que vous parlez déjà et celle que vous voulez apprendre. Ce choix ne peut être fait qu\'une fois.',
  'features.language.sourceLanguage': 'Je parle',
  'features.language.targetLanguage': 'Je veux apprendre',
  'features.language.setupSubmit': 'Enregistrer la paire de langues',

  'features.language.newLesson': 'Nouvelle leçon',
  'features.language.lessonTitle': 'Titre de la leçon',
  'features.language.lessonTitlePlaceholder': 'ex. Salutations',
  'features.language.cancel': 'Annuler',
  'features.language.create': 'Créer',

  'features.language.noLessons': 'Aucune leçon pour le moment. Ajoutez-en une pour commencer.',
  'features.language.wordCount': '{{count}} mots',
  'features.language.removeWordFromLesson': 'Retirer de la leçon',
  'features.language.removeWordFromLessonConfirm': 'Ce mot ne fera plus partie de cette leçon. Il n\'est pas supprimé : il reste disponible dans le dictionnaire partagé.',
  'features.language.subTabLesson': 'La leçon',
  'features.language.subTabVocabulary': 'Le vocabulaire',
  'features.language.backToLessons': 'Retour aux leçons',
  'features.language.words': 'Mots',
  'features.language.noWords': 'Aucun mot dans cette leçon pour le moment.',
  'features.language.addWord': 'Ajouter un mot',
  'features.language.addWordTitleGerman': 'Ajout d\'un mot en allemand',

  'features.language.article': 'Article',
  'features.language.plural': 'Pluriel',
  'features.language.translatePlural': 'Traduire le pluriel',
  'features.language.declensions': 'Déclinaisons',
  'features.language.declensionCase': 'Cas',
  'features.language.declensionForm': 'Forme',
  'features.language.addDeclension': 'Ajouter une déclinaison',
  'features.language.removeDeclension': 'Supprimer la déclinaison',

  'features.language.wordText': 'Mot',
  'features.language.wordTypeLabel': 'Type',
  'features.language.changeWord': 'Changer',
  'features.language.suggestTranslation': 'Suggérer',
  'features.language.noSuggestionFound': 'Aucune suggestion trouvée.',
  'features.language.searchOnline': 'Chercher en ligne',
  'features.language.searchOnlineTooltip': 'Chercher en ligne, ne pas en abuser',
  'features.language.searchOnlineHint': 'Le mot saisi sera envoyé à un service de traduction en ligne (DeepL).',
  'features.language.onlineSuggestionNotice': 'Traduction automatique : vérifie l\'article, le pluriel et le type.',
  'features.language.lessonWordsHintLabel': 'Dans les leçons',
  'features.language.dictionaryHintLabel': 'Dans le dictionnaire',
  'features.language.searchWordPlaceholder': 'Chercher ou saisir un nouveau mot…',
  'features.language.noMatchingWord': 'Aucun mot correspondant — continuez à saisir pour en créer un nouveau.',
  'features.language.reusedWordOptionalTranslationHint': 'Ce mot existe déjà. Vous pouvez éventuellement lui lier une traduction, ou laisser vide.',
  'features.language.addWordError': 'Impossible d\'ajouter ce mot.',
  'features.language.wordAddedKeepAdding': 'Mot ajouté. Vous pouvez en ajouter un autre.',
  'features.language.backToLesson': 'Retour à la leçon',
  'features.language.editWord': 'Modifier le mot',
  'features.language.saveChanges': 'Enregistrer les modifications',
  'features.language.updateWordError': 'Impossible d\'enregistrer ces modifications.',

  'features.language.exportPdf': 'Télécharger le PDF',

  'features.language.configureColors': 'Configurer les couleurs des langues',
  'features.language.colorsPreview': 'Aperçu',

  'features.language.choiceMode': 'Choisir parmi des propositions',
  'features.language.submitAnswer': 'Valider',
  'features.language.correct': 'Correct !',
  'features.language.incorrect0': 'Pas tout à fait.',
  'features.language.incorrect1': 'Presque !',
  'features.language.incorrect2': 'Raté, mais ça va venir.',
  'features.language.incorrect3': 'Ce n\'est pas ça.',
  'features.language.incorrect4': 'Aïe, pas cette fois.',
  'features.language.incorrect5': 'Non, mais accroche-toi !',
  'features.language.incorrect6': 'Perdu, retente ta chance.',
  'features.language.incorrect7': 'Pas encore ça.',
  'features.language.incorrect8': 'Dommage, la prochaine sera la bonne.',
  'features.language.incorrect9': 'Ce n\'était pas la bonne réponse.',
  'features.language.correctAnswerWas': 'Réponse correcte : {{answer}}',
  'features.language.wordScorePercent': 'Maîtrise du mot : {{percent}}%',
  'features.language.continue': 'Continuer',
  'features.language.overallScorePercent': 'Score : {{percent}}%',
  'features.language.testTabDirection': 'Test {{from}} → {{to}}',
  'features.language.testTabRandom': 'Test aléatoire',
  'features.language.testTabResults': 'Résultat',
  'features.language.wordCounter': 'Mot {{current}} / {{total}}',
  'features.language.restartFullTest': 'Recommencer',
  'features.language.resultsPerson': 'Personne',
  'features.language.noAttemptsYet': 'Aucune réponse',
  'features.language.testMode.free': 'Libre',
  'features.language.testMode.choice': 'Choix',
  'features.language.testTabArticles': 'Test des articles',
  'features.language.articleQuestion': 'Quel article va avec ce nom ?',
  'features.language.noArticleWords': 'Aucun nom avec article dans cette leçon pour l\'instant.',
  'features.language.scoreOverTime': 'Note dans le temps',
  'features.language.noChartData': 'Aucune réponse sur cette période.',
  'features.language.chartPeriod.week': '1 semaine',
  'features.language.chartPeriod.month': '1 mois',
  'features.language.chartPeriod.threeMonths': '3 mois',
  'features.language.chartPeriod.all': 'Tout',
  'features.language.testTabPlurals': 'Test des pluriels',
  'features.language.pluralQuestion': 'Saisissez le pluriel de ce nom',
  'features.language.noPluralWords': 'Aucun nom avec pluriel dans cette leçon pour l\'instant.',
  'features.language.scoreExplanationTitle': 'Comment le résultat est-il calculé ?',
  'features.language.scoreExplanationOverall': 'La grosse note est la moyenne des notes de tous les mots de la leçon, pour la personne sélectionnée. Le graphique montre son évolution jour après jour.',
  'features.language.scoreExplanationPoints': 'Chaque mot vaut des points : 6 pour chaque sens de traduction (langue connue vers langue apprise, et inversement), plus 3 pour l\'article et 3 pour le pluriel quand le nom de la langue apprise en a. Un verbe ou un adjectif est sur 12, un nom sur 15 ou 18. La note du mot est le nombre de points obtenus sur les points possibles.',
  'features.language.scoreExplanationDays': 'Une partie gagne ses points sur 3 jours différents de bonnes réponses : répondre juste plusieurs fois le même jour ne compte qu\'une fois, et une partie ne rapporte jamais plus que son maximum.',
  'features.language.scoreExplanationChoice': 'Choisir la traduction parmi des propositions ne compte que pour un cinquième de journée, bien moins que la saisir. Les réponses sur l\'article et le pluriel comptent pleinement.',
  'features.language.scoreExplanationDecay': 'Un mot que tu n\'as pas testé pendant une semaine entière perd 10 % de sa note, puis encore 10 % par semaine supplémentaire, jusqu\'à ce que tu le retravailles.',
  'features.language.reviewComplete': 'Vous avez révisé tous les mots de cette leçon.',
  'features.language.noTestableWords': 'Aucun mot de cette leçon n\'a encore de traduction.',
};

export default fr;
